import {connect} from 'react-redux';
import {Box as Component} from './Box';
import {
  createBox,
  setBoxHeld,
  setHeldObject,
  setBoxControlVisibility,
  hideAllControls,
  setHeld,
  pushInteractions,
  glassTubeItemDrop,
  setBoxesInScene,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("boxes") &&
     state.notebook.protocolSection.scene.apparatus.boxes.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.boxes[ownProps.id-1].type,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.boxes[ownProps.id - 1].controlsVisible,
      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,
      inScene: state.notebook.protocolSection.scene.apparatus.boxes[ownProps.id-1].inScene,
      interactionProps: {
        glassTubes: state.notebook.protocolSection.scene.apparatus.glassTubes,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createBox: (data)=>{
      dispatch(createBox(data))
    },
    setBoxHeld: (data) => {
      dispatch(setBoxHeld(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setBoxControlVisibility: (data) => {
      dispatch(setBoxControlVisibility(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    onDropBox: (data)=>{
      dispatch(glassTubeItemDrop(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
    setBoxesInScene: (data) => {
      dispatch(setBoxesInScene(data))
    },
  };
}

export const Box = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
